import axios from 'axios';
import type { Lideranca } from '@eleg360/types';

export interface FiltroLideranca {
  search?: string;
  bairro?: string;
  tipo?: string;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const liderancasApi = {
  create: async (data: Partial<Lideranca>, token: string) => {
    const res = await axios.post<Lideranca>(`${API_URL}/gab/liderancas`, data, auth(token));
    return res.data;
  },

  list: async (filtros: FiltroLideranca, token: string) => {
    const res = await axios.get<Lideranca[]>(`${API_URL}/gab/liderancas`, {
      ...auth(token),
      params: filtros,
    });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<Lideranca>(`${API_URL}/gab/liderancas/${id}`, auth(token));
    return res.data;
  },

  update: async (id: string, data: Partial<Lideranca>, token: string) => {
    const res = await axios.put<Lideranca>(`${API_URL}/gab/liderancas/${id}`, data, auth(token));
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/gab/liderancas/${id}`, auth(token));
  },
};
